import { GET, POST } from "../../../module/services/fetch";
import { map } from "rxjs/operators";

export const fetchEmergencyUsersList = () =>
  GET("RACFEntitlements").pipe(map((response: any) => response));

export const fetchCreateRequest = (request: FormData) =>
  POST(
    "request/createRequests",
    request,
    undefined,
    undefined,
    undefined,
    "multipart/form-data"
  ).pipe(map((response: any) => response));
